import React from 'react';
import { Star } from 'lucide-react';
import { Product } from '../types';
import { Link } from 'react-router-dom';

interface ProductCardProps {
  product: Product;
}

const ProductCard: React.FC<ProductCardProps> = ({ product }) => (
  <div 
    style={{
      flex: '1 1 280px',
      maxWidth: '320px',
      backgroundColor: '#ffffff',
      borderRadius: '12px',
      overflow: 'hidden',
      boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
      cursor: 'pointer',
      transition: 'transform 0.2s',
    }}
    onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-8px)'}
    onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
  >
    <Link to={`/product/${product._id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
      <img 
        src={product.image} 
        alt={product.name}
        style={{ width: '100%', height: '250px', objectFit: 'cover' }}
      />
      <div style={{ padding: '1.5rem' }}>
        <h4 style={{ margin: '0 0 0.5rem 0', color: '#303030', fontSize: '1.25rem' }}>
          {product.name}
        </h4>
        <p style={{ color: '#6d9ac7', fontSize: '0.9rem', marginBottom: '1rem' }}>
          {product.category}
        </p>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#1269cc' }}>
            ${product.price}
          </span>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.25rem' }}>
            <Star size={16} fill="#51eefc" color="#51eefc" />
            <span style={{ color: '#303030' }}>{product.rating}</span>
          </div>
        </div>
      </div>
    </Link>
  </div>
);

export default ProductCard;